// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChartTooltipSharedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChartTooltipSharedIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M8 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path d="M7 15.247a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M8 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path d="M4 2.25a1 1 0 0 0-1 1v13.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3.25a1 1 0 0 0-1-1zM4.5 9h11v7.25h-11zm0-1.25v-4h11v4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ChartTooltipSharedIcon = /* @__PURE__ */ Object.assign(
  ChartTooltipSharedIconComponent,
  { displayName: 'ChartTooltipSharedIcon' },
);
